import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import Footer from "../../../customComponents/Footer";
import { OtcTradeApi } from "./otcTradeApi";
import { isClosedRequest, receiveLine, requestWhen, stageLabel, statusTone } from "./tradeStatus";
import "../OtcDesk/otc-desk.css";
import "./otc-trade.css";

function TradeDetail({ row, onClose }) {
  return createPortal(
    <div className="otc-trade-overlay" onClick={onClose}>
      <div className="otc-trade-popup" role="dialog" aria-modal="true" aria-labelledby="otc-history-view-title" onClick={(event) => event.stopPropagation()}>
        <button type="button" className="otc-trade-close" aria-label="Close" onClick={onClose}>×</button>
        <h2 id="otc-history-view-title">{row.number}</h2>
        <p className="otc-trade-lead">{requestWhen(row.createdAt || row.updatedAt)}</p>
        <dl>
          <dt>Pair</dt><dd>{row.pairSymbol}</dd>
          <dt>Type</dt><dd>{row.category === "fiat" ? "Fiat spot" : "Crypto"}</dd>
          <dt>You pay</dt><dd>{row.payAmount} {row.payAsset}</dd>
          <dt>You get</dt><dd>{row.getAmount} {row.getAsset}</dd>
          <dt>Status</dt><dd><span className={`otc-status-chip ${statusTone(row.status)}`}>{stageLabel(row.status, row)}</span></dd>
          <dt>Receive</dt><dd>{receiveLine(row)}</dd>
          <dt>Purpose</dt><dd>{(row.dd && row.dd.purpose) || (row.clientDetails && row.clientDetails.purpose) || "—"}</dd>
          {row.dd && row.dd.direction === "crypto_to_fiat" ? (
            <>
              <dt>Currency</dt><dd>{row.dd.currency || "AED"}</dd>
              <dt>Demand draft amount</dt><dd>{row.dd.amount || row.getAmount} {row.dd.currency || row.getAsset}</dd>
              <dt>Amount in words</dt><dd>{row.dd.amountInWords || "—"}</dd>
              <dt>Collection</dt><dd>Office Collection</dd>
            </>
          ) : null}
          {row.status === "REJECTED" ? <><dt>Reason</dt><dd>{row.rejectReason || "—"}</dd></> : null}
        </dl>
      </div>
    </div>,
    document.body
  );
}

export default function OtcTradeHistory() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [selectedId, setSelectedId] = useState("");

  useEffect(() => {
    let stop = false;
    OtcTradeApi.requests().then((res) => {
      if (stop) return;
      setLoading(false);
      if (!res || res.success === false) {
        setError((res && res.message) || "Trade history could not be loaded.");
        setRows([]);
        return;
      }
      const list = Array.isArray(res.data) ? res.data : [];
      setRows(list.filter((row) => isClosedRequest(row.status)));
    }).catch(() => {
      if (stop) return;
      setLoading(false);
      setError("Trade history could not be loaded.");
    });
    return () => { stop = true; };
  }, []);

  const selected = rows.find((row) => (row._id || row.id || row.number) === selectedId) || null;

  return (
    <>
      <Helmet>
        <title>OTC Trade History | AGCX</title>
      </Helmet>
      <main className="otc-history-page">
        <div className="otc-history-wrap">
          <Link to="/otc-trade" className="otc-history-back">OTC trade</Link>
          <h1>Trade history</h1>
          <p className="otc-history-lead">Completed, delivered, rejected, and cancelled trades.</p>
          {loading ? <p className="otc-history-empty">Loading trades…</p> : null}
          {error ? <p className="otc-history-empty">{error}</p> : null}
          {!loading && !error && !rows.length ? <p className="otc-history-empty">No completed trades yet.</p> : null}
          {!loading && !error && rows.length ? (
            <div className="trades-table-card otc-history-table">
              <table className="trades-table">
                <thead>
                  <tr>
                    <th>Trade</th>
                    <th>Date</th>
                    <th>Pair</th>
                    <th>You pay</th>
                    <th>You get</th>
                    <th>Status</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row) => {
                    const id = row._id || row.id || row.number;
                    return (
                      <tr key={id}>
                        <td data-label="Trade">{row.number}</td>
                        <td data-label="Date">{requestWhen(row.createdAt || row.updatedAt)}</td>
                        <td data-label="Pair">{row.pairSymbol}</td>
                        <td data-label="You pay">{row.payAmount} {row.payAsset}</td>
                        <td data-label="You get">{row.getAmount} {row.getAsset}</td>
                        <td data-label="Status"><span className={`otc-status-chip ${statusTone(row.status)}`}>{stageLabel(row.status, row)}</span></td>
                        <td data-label=""><button type="button" onClick={() => setSelectedId(id)}>View</button></td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : null}
          {selected ? <TradeDetail row={selected} onClose={() => setSelectedId("")} /> : null}
        </div>
      </main>
      <Footer />
    </>
  );
}
